import { gql } from 'apollo-boost'

const SCRAPING_TAG_GROUPS = gql`
  query scrapingTagGroups(
    $filters: ScrapingTagGroupFiltersInput!
    $page: Int
    $pageSize: Int
  ) {
    scrapingTagGroups(filters: $filters, page: $page, pageSize: $pageSize) {
      scrapingTagGroups {
        id
        name
        alias
        description
        tags {
          id
          name
          type
        }
        scrapingTestCaseCount
        createdBy {
          id
          name
        }
        lastModifiedBy {
          id
          name
        }
      }
      total
    }
  }
`

export default SCRAPING_TAG_GROUPS
